import groq from 'groq';

export const ASSET = groq`
  _key,
  _type,
  alt,
  asset -> {
    _id
  }
`;
